import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import { ILand } from "src/modules/pe-fest-module/data/interfaces";
import LandContent from './LandContent';   

interface IProps {
    item : ILand
    onClose: () => void
    onOpenLogin?: () => void
    isNarrow?: boolean
}
const EventContent = (props: IProps) : JSX.Element => {
    return <LandContent {...props} /> 
} 

export default EventContent